// extracted by mini-css-extract-plugin
module.exports = {"nav-bar":"GeneralNavigation_nav-bar__3PYBx","nav-bar__left":"GeneralNavigation_nav-bar__left__1P9P1","navbar-fixed":"GeneralNavigation_navbar-fixed__3NiGw"};